import { API_ROUTES } from "./constants";
import { getToken } from "./getToken";

// Get all products
export const getAllProducts = async () => {
  const token = getToken();
  if (!token) {
    throw new Error("No authentication token found");
  }

  const response = await fetch(API_ROUTES.GET_ALL_PRODUCTS, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.message || `Error: ${response.status}`);
  }

  const result = await response.json();
  return result.data || result;
};

// Create product
export const createProduct = async (productData) => {
  const token = getToken();
  if (!token) {
    throw new Error("No authentication token found");
  }

  const response = await fetch(API_ROUTES.CREATE_PRODUCT, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(productData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.message || `Error: ${response.status}`);
  }

  const result = await response.json();
  return result.data || result;
};

// Update product
export const updateProduct = async ({ id, productData }) => {
  const token = getToken();
  if (!token) {
    throw new Error("No authentication token found");
  }

  const response = await fetch(`${API_ROUTES.UPDATE_PRODUCT}/${id}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(productData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.message || `Error: ${response.status}`);
  }

  const result = await response.json();
  return result.data || result;
};

// Delete product
export const deleteProduct = async (id) => {
  const token = getToken();
  if (!token) {
    throw new Error("No authentication token found");
  }

  const response = await fetch(`${API_ROUTES.DELETE_PRODUCT}/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.message || `Error: ${response.status}`);
  }

  const result = await response.json();
  return result;
};